<template>
    <div class="l-section">
        <ul class="list-caution">
            <li class="list-caution-item">品質向上のため、デザインは予告なく変更する可能性がございます。</li>
            <li class="list-caution-item">電波状況や設置店の場所により、携帯転送に対応していない場合があります。詳しくはお店に確認をお願いします。</li>
        </ul>
        <div class="frame-sns">
            <span class="heading-marker">プリの情報をどこよりも早くお届け！</span>
            <div class="list-sns l-element">
                <div class="list-sns-text l-element">
                    <span class="is-light">フリューの公式SNS</span>
                </div>
                <div class="l-element">
                    <a :href="twitterUrl" target="_blank" @click="ga4ClickEvent(twitterUrl, twitterAlt)" data-jest="link-twitter">
                        <img class="list-sns-icon" :src="buildImageUrl('/img/icon/btn_icon_twitter_x.png')" :alt="twitterAlt">
                    </a>
                </div>
                <div class="l-element">
                    <a :href="instagramUrl" target="_blank" @click="ga4ClickEvent(instagramUrl, instagramAlt)" data-jest="link-instagram">
                        <img class="list-sns-icon" :src="buildImageUrl('/img/icon/btn_icon_instagram.png')" :alt="instagramAlt">
                    </a>
                </div>
                <div class="l-element">
                    <a :href="lineUrl" target="_blank" @click="ga4ClickEvent(lineUrl, lineAlt)" data-jest="link-line">
                        <img class="list-sns-icon" :src="buildImageUrl('/img/icon/btn_icon_line.svg')" :alt="lineAlt">
                    </a>
                </div>
                <div class="l-element">
                    <a :href="tiktokUrl" target="_blank" @click="ga4ClickEvent(tiktokUrl, TikTokAlt)" data-jest="link-tiktok">
                        <img class="list-sns-icon" :src="buildImageUrl('/img/icon/btn_icon_tiktok.png')" :alt="TikTokAlt">
                    </a>
                </div>
            </div>
        </div>
        <a :href="machineListUrl" v-if="!isHideBtnMachineList && !isAppli" class="btn-machineList" @click="ga4ClickEvent(machineListUrl, machineListBtnText)" data-jest="link-machine-list">{{ machineListBtnText }}</a>
    </div>
</template>

<script>
    import * as urlUtil from '../../util/UrlUtil'
    import {getClickAllEvent} from "../../util/Ga4EventUtil";
    import {mapActions, mapGetters} from "vuex";
    import UserAgentUtil from "../../util/UserAgentUtil.js";

    export default {
        name: "MachineAppealSns",
        props: {
            isHideBtnMachineList: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        data() {
            return {
                twitterUrl: urlUtil.snsUrlUtil.officialTwitterUrl(),
                instagramUrl: urlUtil.snsUrlUtil.officialInstagramUrl(),
                lineUrl: urlUtil.snsUrlUtil.officialLineUrl(),
                tiktokUrl:urlUtil.snsUrlUtil.officialTikTokUrl(),
                machineListUrl: urlUtil.servletUrlUtil.machineListUrl(),
                twitterAlt: 'フリュー公式Twitter',
                instagramAlt: 'フリュー公式Instagram',
                lineAlt: 'フリュー公式LINE',
                TikTokAlt: 'フリュー公式TikTok',
                machineListBtnText: 'プリ機一覧',
                userAgent: new UserAgentUtil(),
            }
        },
        computed: {
            ...mapGetters(
                'AccountStoreV2', ['isAppli']
            ),
        },
        methods: {
            ...mapActions({
                getIsAppli: 'AccountStoreV2/getIsAppli'
            }),
            ga4ClickEvent(elUrl, elText) {
                getClickAllEvent(elUrl, elText)
            },
            buildImageUrl(url)  {
                return urlUtil.imageUrlUtil.buildImageUrl(url)
            }
        },
        mounted() {
            this.getIsAppli(this.userAgent.isAppli)
        }
    }
</script>

<style lang="scss" scoped>
    @use '../../../scss/v2/base/variables';
    //紹介ページによってimportしてるcssが異なり、remなどに差が出るため、
    //コンポーネント等使用せず、全てベタ書きで実装しています。
    //cssが統一できたらcomponentにしたいです。

    // 基本の余白
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px

    .l-section {
        padding: $grid-base;
        background-color: variables.$color-white;
    }

    /*
    // LEGO式wrapクラス
    // 基本的な余白をつけたい時に付与する
    */
    .l-element {
        padding: $grid-consistent;
    }


    .frame-sns{
        text-align: center;
        margin: $grid-consistent*4 0 $grid-consistent*2 0;

        .heading-marker {
            text-align: center;
            color: variables.$color-pictlink-black-50;
            line-height: 1.5;
            font-size: 14px;
            font-weight: bold;
            span {
                color: inherit;
            }
            background: linear-gradient(transparent 50%, rgba(variables.$color-pictlink-pink, variables.$opacity-30) 0%);
        }

        .list-sns {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            &-text {
                font-size: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: variables.$color-pictlink-black-50;
            }
            &-icon {
                width: $grid-consistent*5;
            }
        }
    }


    .btn-machineList {
        width: 100%;
        height: 46px;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        flex-wrap: wrap;
        border: 1px solid variables.$color-pictlink-pink;
        color: variables.$color-pictlink-pink;
        background-color: variables.$color-white;
        text-align: center;
        font-size: 16px;
        border-radius: 6px;
        cursor: pointer;
        text-decoration: none;
    }


    .list-caution {
        padding-left:15px;
        &-item {
            color: variables.$color-pictlink-black-50;
            font-size: 10px;
            line-height: 1.5;
            list-style-type: disc;
            margin-bottom: $grid-consistent * 0.5;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

</style>
